namespace RioERP.Orders {
    export interface EaseBuzzSettingsForm {
        Key: Serenity.StringEditor;
        Salt: Serenity.StringEditor;
        WebhookUrl: Serenity.StringEditor;
        RedirectUrl: Serenity.StringEditor;
    }

    export class EaseBuzzSettingsForm extends Serenity.PrefixedContext {
        static formKey = 'Orders.EaseBuzzSettings';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!EaseBuzzSettingsForm.init)  {
                EaseBuzzSettingsForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;

                Q.initFormType(EaseBuzzSettingsForm, [
                    'Key', w0,
                    'Salt', w0,
                    'WebhookUrl', w0,
                    'RedirectUrl', w0
                ]);
            }
        }
    }
}
